var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"example-species__total-count"},[_vm._v("\n  "+_vm._s(_vm.speciesCountMessage)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }